<template>
  <div class="modal-add-course">
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Managers</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" @click="toggleModal()"
                      >&times;</span
                    >
                  </button>
                </div>
                <div class="modal-body">
                  <div class="managers-course">
                    <div>
                        <table class="table table-hover w-100 shadow">
                          <thead class="thead-dark">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Email</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="collection-item" v-for="(user, index) in allManagers" :key="index">
                              <th scope="row">{{index+1}}</th>
                              <td>{{user.email}}</td>
                              <td>
                                <div v-if="managersa">
                                  <input type="checkbox" :id="user.id" v-if="managersa.includes(user.id)" checked @click="deleteItem(user.id)">
                                  <input type="checkbox" :id="user.id" v-else @click="addItem(user.id)">
                                </div>
                                <div v-else>
                                  <input type="checkbox" :id="user.id" @click="addItem(user.id)">
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import { es } from "vuejs-datepicker/src/locale";

export default {
  name: "ModalManagers",
  data() {
    return {
      managersa: [],
      allManagers: [],
      courseId: "",
    };
  },
  created() {
    //this.getCourseManager()
  },
  computed: {
    showModal() {
      this.managers()
      return this.$store.getters.showModalManagers;
    },
  },
  watch: {},
  methods: {
    async managers() {
      const course = await this.$store.getters.getCourseManager
      if (course) {
        const allUsers = await this.$store.getters.getListUsers();
        this.allManagers = allUsers;
        const courseRef = firebase.firestore().collection("courses").doc(course)
        const docCourse = await courseRef.get()
        const dataCourse = docCourse.data();
        this.managersa = dataCourse.managers;
        this.courseId = course;
      }
    },
    toggleModal() {
      this.$store.dispatch("toggleModalManagers");
    },
    async deleteItem(id) {
      const courseRef = firebase.firestore().collection("courses").doc(this.courseId);
      courseRef.update({
          managers: firebase.firestore.FieldValue.arrayRemove(id)
      });
      this.managers();
    },
    async addItem(id) {
      const courseRef = firebase.firestore().collection("courses").doc(this.courseId);
      courseRef.update({
          managers: firebase.firestore.FieldValue.arrayUnion(id)
      });
      this.managers();
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  -webkit-transition: opacity 500ms ease-in;
  -moz-transition: opacity 500ms ease-in;
  transition: opacity 500ms ease-in;
  overflow: auto;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-header {
  background-color: #007bff;
  color: #fefefe;
}
.modal-header span {
  color: #fefefe;
}
.form-group {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/Managers.vue